/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';
import { GET_TASK_USERS, CREATE_NEW_TASK, GET_TASK_TYPE, GET_QUASI_SECTION_QUESTION } from '../../../../action/apiPath';
import { CallWithAuth } from '../../../../action/apiActions';
import style from '../../../../assets/styles/taskManagement.module.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  Task_Screen_Change,
  Get_Task_QuestionBank_List,
  createActivity,
  Get_Task_Type,
} from '../../../../redux/action';
import NativeButton from '../../../atoms/Button';
import PageLayout from '../../../atoms/PageLayout';
import { useToast } from '../../common/Toast';
import { useNavigate, useParams } from 'react-router-dom';
import arrowIcon from '../../../../assets/images/upArrow.svg';
import BrowsingQuestion from './TaskBrowsingQuestion';
import RecentActivity from './RecentActivity';
import style2 from '../../../../assets/styles/viewTaskDetail.module.css';
import ruleDelete from '../../../../assets/images/sectionDelete.svg';

const AddTask = () => {
  const dispatch = useDispatch();
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
  const userId = userInfo.id;
  const firstName = userInfo.first_name || '';
  const lastName = userInfo.last_name || '';
  //__________________  ADD TASK ___________________
  const [taskType, setTaskType] = useState(1);
  // const [taskTypeList, setTaskTypeList] = useState([]);
  const [approversInfo, setApproversInfo] = useState([{ id: userId, name: firstName + ' ' + lastName }]);
  const [taskDetailsInfo, setTaskDetailsInfo] = useState('');
  const [endDateInfo, setEndDateInfo] = useState('');
  const [questionBankId, setQuestionBankId] = useState(null);
  const [numberOfQue, setNumberOfQue] = useState(null);
  /*** ASSIGNEES FROM USERS */
  const [assigneefreeTaginput, setAssigneefreeTaginput] = useState('');
  const [assigneefreeTag, setAssigneefreeTag] = useState([]);
  const [assigneefreeTagStatus, setAssigneefreeTagStatus] = useState(false);

  /*** APPROVALS */
  const [approvalsfreeTaginput, setApprovalsfreeTaginput] = useState('');
  const [approvalsfreeTag, setApprovalsfreeTag] = useState([]);
  const [approvalsfreeTagStatus, setApprovalsfreeTagStatus] = useState(false);
  const [selectedAssignee, setSelectedAssignee] = useState({ id: null, name: '' });
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [questionData, setQuestionData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectIds, setSelectIds] = useState([]);
  const [isEditFields, setIsEditFields] = useState(true);
  const toast = useToast();
  const navigate = useNavigate();
  const { taskId } = useParams();
  /** QUESTION BANK APIS CALLING */
  const { questionBank, taskQueBankListBody, taskTypeList } = useSelector((state) => state.GetAllData);
  const organizationId = localStorage.getItem('selectedOrgId');
  const currentDate = new Date().toISOString();
  const [editTaskData, setEditTaskData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [onMouseHover, setOnMouseHover] = useState(false);
  useEffect(() => {
    if (!taskTypeList) {
      dispatch(Get_Task_Type());
    }
    dispatch(Get_Task_QuestionBank_List(organizationId));
  }, []);
  useEffect(() => {
    console.log(questionData, 'questionData');
  }, [questionData, taskType, taskDetailsInfo, selectedQuestionId]);

  useEffect(() => {
    if (taskId) {
      getTaskDetails();
    }
  }, [taskId]);

  /*** DYNAMICALLY CALLING DROPDOWN DATA FOR QUESTION AND TEST */
  const [selectedRadio, setSelectedRadio] = useState(1);
  const [dropdownOptions, setDropdownOptions] = useState([]);

  useEffect(() => {
    if (taskQueBankListBody) {
      setDropdownOptions(taskQueBankListBody);
    }
  }, [taskQueBankListBody]);

  const handleRadioChange = (e, id) => {
    dispatch(Get_Task_QuestionBank_List(organizationId));
    const selectedValue = e.target.value;
    setSelectedRadio(id);
    setTaskType(id);
    let dataIncoming = [];
    if (selectedValue === 'Question') {
      dataIncoming = questionBank;
    } else {
      // eslint-disable-next-line no-console
      console.error('ERROR');
    }
    setDropdownOptions(dataIncoming);
  };

  const getTaskDetails = async (e) => {
    setIsLoading(true);
    try {
      const data = await CallWithAuth('GET', `${CREATE_NEW_TASK}${taskId}/task-details/${organizationId}/`);
      setIsLoading(false);
      if (data.status && data.res.status === 200) {
        if (data.res.data.data) {
          const taskdetails = data.res.data.data;
          setEditTaskData(taskdetails);
          setTaskType(taskdetails.task_type?.id);
          setSelectedRadio(taskdetails.task_type?.id);
          if (taskdetails.task_type?.id === 3) {
            setSelectedQuestionId(taskdetails.question[0]);
            QuestionListing(taskdetails.question[0]);
          }
          setEndDateInfo(taskdetails.end_date);
          setSelectedAssignee(taskdetails.assignee);
          setApproversInfo(taskdetails.approvers);
          setTaskDetailsInfo(taskdetails.task_details);
          setQuestionBankId(taskdetails?.question_bank?.id);
          setNumberOfQue(taskdetails?.no_of_question ?? '');
          setIsEditFields(taskdetails.is_edit);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // CALL GET API FOR getting TAGS
  const AssigneeLists = async (e) => {
    setAssigneefreeTaginput(e);
    if (e.length > 1) {
      const data = await CallWithAuth('GET', `${GET_TASK_USERS}${organizationId}/?keyword=${e}`);
      if (data.status && data.res.status === 200) {
        if (data.res.data.length > 0) {
          setAssigneefreeTag(data.res.data);
          setAssigneefreeTagStatus(true);
        } else {
          setAssigneefreeTagStatus(false);
        }
      }
    } else {
      setAssigneefreeTagStatus(false);
    }
  };

  // CALL FOR APPROVERS
  const ApprovalLists = async (e) => {
    setApprovalsfreeTaginput(e);
    if (e.length > 1) {
      const data = await CallWithAuth('GET', `${GET_TASK_USERS}${organizationId}/?keyword=${e}`);
      if (data.status && data.res.status === 200) {
        if (data.res.data.length > 0) {
          setApprovalsfreeTag(data.res.data);
          setApprovalsfreeTagStatus(true);
        } else {
          setApprovalsfreeTagStatus(false);
        }
      }
    } else {
      setApprovalsfreeTagStatus(false);
    }
  };

  // select tags from options
  const selectAssigneeTag = (e) => {
    setAssigneefreeTagStatus(false);
    setSelectedAssignee({ id: e.id, name: e.name });
    setAssigneefreeTaginput('');
  };

  const handleRemoveAssignee = () => {
    setSelectedAssignee({});
  };

  // select tags from options
  const selectApprovalTag = (e) => {
    setApproversInfo((current) => {
      // Check if the ID already exists in the array
      if (!current.some((item) => item.id === e.id)) {
        return [...current, e];
      }
      return current; // If it exists, return the current state unchanged
    });
    setApprovalsfreeTagStatus(false);
    setApprovalsfreeTaginput('');
  };

  const cancelApprovalButoon = (index) => {
    const updatedApprovers = approversInfo.filter((_, i) => i !== index);
    setApproversInfo(updatedApprovers);
  };

  /*** Local date converter */
  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const formatedDate = endDateInfo ? formatDate(new Date(endDateInfo)) : '';

  /*** Body for create task API */
  let queAuthoringbody = {
    org_id: Number(organizationId),
    task_type: taskType,
    assignee: selectedAssignee?.id ?? null,
    approvers: approversInfo?.map((item) => item.id) ?? [],
    task_details: taskDetailsInfo,
    end_date: formatedDate,
    question_bank: questionBankId,
    no_of_questions: numberOfQue,
  };

  let testAuthoringbody = {
    org_id: Number(organizationId),
    task_type: taskType,
    assignee: selectedAssignee?.id ?? null,
    approvers: approversInfo?.map((item) => item.id) ?? [],
    task_details: taskDetailsInfo,
    end_date: formatedDate,
    question_bank: questionBankId,
  };

  let queEditbody = {
    org_id: Number(organizationId),
    task_type: taskType,
    assignee: selectedAssignee?.id ?? null,
    approvers: approversInfo?.map((item) => item.id) ?? [],
    task_details: taskDetailsInfo,
    end_date: formatedDate,
    question: selectedQuestionId,
    question_bank: questionBankId,
  };

  /***Fn Selelcting QuestionBank and ProductTest for task creation */
  const handleQuestionSelect = (e) => {
    const questionId = e.target.value;
    if (questionId == 'Choose question bank') {
      setQuestionBankId(null);
    } else {
      setQuestionBankId(Number(questionId));
    }
  };

  /*** Fn for Selelcting number of questions for task creation */
  const NumOfQuestions = (e) => {
    const questionNumber = e.target.value === '' ? e.target.value : Number(e.target.value);
    setNumberOfQue(questionNumber);
  };

  /*** User cannot select gone by dates */
  const [date, setDate] = useState('');

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setDate(today);
  }, []);
  const handleCancel = () => {
    if (!taskId) {
      setApproversInfo([]);
      setTaskDetailsInfo('');
      setEndDateInfo('');
      setQuestionBankId('');
      setNumberOfQue('');
      setAssigneefreeTaginput('');
      setAssigneefreeTag([]);
      setAssigneefreeTagStatus(false);
      setApprovalsfreeTaginput('');
      setApprovalsfreeTag([]);
      setApprovalsfreeTagStatus(false);
      setSelectedAssignee({ id: null, name: '' });
      setIsEditFields(true);
    } else {
      if (editTaskData) {
        const taskdetails = editTaskData;
        setTaskType(taskdetails.task_type?.id);
        setSelectedRadio(taskdetails.task_type?.id);
        if (taskdetails.task_type?.id === 3) {
          setSelectedQuestionId(taskdetails.question[0]);
          QuestionListing(taskdetails.question[0]);
        }
        setEndDateInfo(taskdetails.end_date);
        setSelectedAssignee(taskdetails.assignee);
        setApproversInfo(taskdetails.approvers);
        setTaskDetailsInfo(taskdetails.task_details);
        setQuestionBankId(taskdetails?.question_bank?.id);
        setNumberOfQue(taskdetails?.no_of_question ?? '');
        setIsEditFields(taskdetails.is_edit);
      }
    }
  };
  const handleAssignTask = async () => {
    let paylaod;
    if (taskType === 1) {
      paylaod = queAuthoringbody;
    } else if (taskType === 2) {
      paylaod = testAuthoringbody;
    } else {
      paylaod = queEditbody;
    }
    try {
      const URl = taskId ? CREATE_NEW_TASK + `${taskId}/edit_task/` : CREATE_NEW_TASK + `create-task/`;
      const method = taskId ? 'PATCH' : 'POST';
      const data = await CallWithAuth(method, URl, paylaod);
      if (data.status && (data.res.status === 201 || data.res.status === 200)) {
        if (toast) {
          toast.remove('all');
          toast.add(String(data.res.data.message), 'success');
          navigate(`/task-management`);
          if (!taskId) {
            dispatch(createActivity(data.res.data.data.id, userId, 1, currentDate, toast));
          }
          // else{
          //   const isAssigneeEdited = selectedAssignee?.id !== editTaskData?.assignee?.id;
          //   const previousApprovers = editTaskData?.approvers?.map(item => item.id) || [];
          //   const newApprovers = approversInfo?.map(item => item.id) || [];

          //   const isApproversEdited =
          //   previousApprovers.length !== newApprovers.length ||
          //   previousApprovers.some(id => !newApprovers.includes(id));
          //   if(isAssigneeEdited){
          //     dispatch(createActivity(data.res.data.data.id, userId, 6, currentDate, toast));
          //   }
          //   if(isApproversEdited){
          //     dispatch(createActivity(data.res.data.data.id, userId, 7, currentDate, toast));
          //   }
          // }
        }
      } else {
        if (toast) {
          toast.remove('all');
          toast.add(String(data.res.data.error), 'error');
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const QuestionListing = async (questionId) => {
    const url = `${GET_QUASI_SECTION_QUESTION}${organizationId}/?question_ids=${questionId}`;
    try {
      const questionlistingData = await CallWithAuth('GET', url);
      if (questionlistingData.status && questionlistingData.res.status === 200) {
        const fetchedQuestions = questionlistingData.res.data;
        setQuestionData(fetchedQuestions);
        const queBankId = fetchedQuestions[0]?.questions[0]?.question_bank;
        setQuestionBankId(Number(queBankId));
      }
    } catch (error) {
      console.error('Error fetching question listing data:', error);
    }
  };
  const addTaskQuestion = () => {
    setModal(true);
  };

  const addQuestionToTask = () => {
    if (!selectedQuestionId) {
      toast.add('Please select a question to add', 'error');
      return;
    }
    setModal(false);
    QuestionListing(selectedQuestionId);
  };

  const questionDelete = () => {
    setQuestionData([]);
    setSelectedQuestionId(null);
  };
  return (
    <>
      <PageLayout title={'Task Management'}>
        {!isLoading && (
          <>
            <div className={style.createTask}>
              <div className={style.top_section}>
                <NativeButton
                  onClick={() => {
                    dispatch(Task_Screen_Change(0));
                    navigate(`/task-management`);
                  }}
                >
                  <span style={{ cursor: 'pointer' }} className={style.left}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.5488 19.422L9.02883 12.902C8.25883 12.132 8.25883 10.872 9.02883 10.102L15.5488 3.58203"
                        stroke="#212529"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Back
                  </span>
                </NativeButton>
              </div>

              <div className={style.table_content_report} style={{ overflowX: 'hidden', background: '#ffffff' }}>
                {taskId && (
                  <div
                    style={{ display: 'flex', gap: '5px' }}
                    className={` ${style.top_content_table} ${style.profile_title_div}`}
                  >
                    <span style={{ color: '#8E9EAB', fontSize: '17px' }}>Task ID </span>
                    <span> &nbsp;{taskId}</span>
                  </div>
                )}

                <div className={` ${style.select_question} ${style.profile_status}`}>
                  <div className={`${style.info} ${!taskId ? style.marginTopInfo : ''}`}>
                    {/* format  */}
                    <div className={style.format}>
                      <div className={style.format_title}>{taskId ? 'Update task for' : 'Create new task for'}</div>
                      <div className={style.format_choice}>
                        {taskTypeList?.map((task) => (
                          <div key={task.id}>
                            <input
                              type="radio"
                              className={style.custom_radio}
                              style={{ cursor: `${taskId ? 'auto' : 'pointer'}` }}
                              id={task.type.replace(/\s+/g, '').toLowerCase()} // Generates unique IDs
                              onChange={(e) => handleRadioChange(e, task.id)}
                              name={`choose_question-${task.id}`}
                              value={task.id}
                              checked={selectedRadio === task.id}
                              autoComplete="off"
                              disabled={taskId}
                            />
                            <label htmlFor={task.type.replace(/\s+/g, '').toLowerCase()}>{task.type}</label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {taskType !== 3 && (
                  <div className={style.user_profile}>
                    <div className={style.tags}>
                      <div className={style.subject}>
                        <p>
                          Question Bank <b className={style.red_mendantory}>*</b>
                        </p>
                        <div className={style.header_drop} style={{ position: 'relative' }}>
                          <select
                            className={`${style.dropdown_css} ${style.queBank} select-focused`}
                            id="searchInput"
                            onChange={(e) => handleQuestionSelect(e)}
                            value={questionBankId}
                            style={{
                              color:
                                questionBankId || (questionBankId != '' && questionBankId != null)
                                  ? 'black'
                                  : '#8E9EAB',
                            }}
                            placeholder="Choose question bank"
                            name="searchInput"
                            autoComplete="off"
                            disabled={taskId && !isEditFields}
                          >
                            <option value={null}>Choose question bank</option>
                            {dropdownOptions.length > 0 &&
                              dropdownOptions?.map((question, index) => (
                                <option key={index + question.id} value={question.id}>
                                  {question.name}
                                </option>
                              ))}
                          </select>
                          {/* <img src={arrowIcon} alt="Custom Arrow" className={style.dropdownSelectArrow} /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {taskType === 3 &&
                  (questionData?.length > 0 ? (
                    <div className={`${style2.TaskViewDetail_QuestionList} ${style.TaskCreateQuestionList}`}>
                      <div className={style2.questionListHeader} style={{ padding: '0px' }}>
                        <span>Added Question:</span>
                      </div>
                      {questionData
                        .flatMap((data) => data.questions)
                        .map((question, index) => (
                          <div key={index} className={style2.questionListingCard} style={{ margin: '25px 0px 16px' }}>
                            <div className={`${style2.cardHeader} ${style.taskCardHeader}`}>
                              <div className={style.questionId} style={{ width: isEditFields ? '80%' : '100%' }}>
                                <span className={style.questionNumber}>ID:</span> {question.question_id}
                              </div>
                              {isEditFields && (
                                <div style={{ width: '20%', textAlign: 'right' }}>
                                  <img
                                    src={ruleDelete}
                                    className={style.iconInfo}
                                    style={{ margin: '0px 0px 0px 8px', cursor: 'pointer' }}
                                    alt="delete"
                                    onClick={questionDelete}
                                  />
                                </div>
                              )}
                            </div>
                            <div className={style2.cardBody}>
                              <div className={style2.tags}>
                                <span className={style2.primaryTag}>{question.primary_tag?.slug}</span>
                              </div>
                              <div className={style2.questionIdentifier}>
                                <span className={style2.shortIdentifier}>{question.question_short_identifier}</span>
                              </div>
                              <div className={`${style2.general_tag}`}>
                                {question.free_tags?.map((tag, i) => (
                                  <button key={i} className={`${style2.general_button}`}>
                                    {tag}
                                  </button>
                                ))}
                              </div>
                              <div className={style2.questionListInfo}>
                                <div className={style2.AuthorDataWrap}>
                                  <span className={style2.labelTitle}>Author:</span>
                                  <div className={style2.labelText}>{question.created_by}</div>
                                </div>
                                <div className={style2.AcademicYearDataWrap}>
                                  <span className={style2.labelTitle}>Academic Year:</span>
                                  <div className={style2.labelText}>{question.academic_year}</div>
                                </div>
                                <div className={style2.CreatedOnDataWrap}>
                                  <span className={style2.labelTitle}>Created On:</span>
                                  <div className={style2.labelText}>{question.created_at}</div>
                                </div>
                                <div className={style2.TypeDataWrap}>
                                  <span className={style2.labelTitle}>Type:</span>
                                  <div className={style2.labelText}>{question.type}</div>
                                </div>
                                <div className={style2.LODDataWrap}>
                                  <span className={style2.labelTitle}>LOD:</span>
                                  <div className={style2.labelText}>{question.difficulty}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }} className={style.threshold}>
                      <div className={style.setter} style={{ margin: '10px 0' }} onClick={addTaskQuestion}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                            stroke="#00ABFB"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M7.5 12H16.5"
                            stroke="#00ABFB"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 16.5V7.5"
                            stroke="#00ABFB"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <h5 style={{ margin: '0' }}>Add Question</h5>
                      </div>
                    </div>
                  ))}

                <div className={style.user_profile}>
                  <div className={style.tags}>
                    <div className={style.subject}>
                      <p>
                        Assignee <b className={style.red_mendantory}>*</b>{' '}
                      </p>
                      {selectedAssignee?.name ? (
                        <div className={style.input_search}>
                          <div className={style.selectedAssignee}>
                            <span>{selectedAssignee.name}</span>
                            <div className={`${style.cancel_button} ${style.cancel_button_assignee}`}>
                              <button className={style.pointer} onClick={handleRemoveAssignee}>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.75781 7.75781L16.2431 16.2431"
                                    stroke="#272727"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M7.75691 16.2431L16.2422 7.75781"
                                    stroke="#272727"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <input
                          className={`${style.input_search} ${style.paddingInput} select-focused`}
                          type="search"
                          id="searchInput"
                          placeholder="Search assignee name"
                          value={assigneefreeTaginput}
                          onChange={(e) => AssigneeLists(e.target.value)}
                          autoComplete="off"
                          onBlur={() => {
                            if (!onMouseHover) {
                              AssigneeLists('');
                              //setmultiSubjectTag([]);
                              setAssigneefreeTagStatus(false);
                              setAssigneefreeTag([]);
                            }
                          }}
                        />
                      )}
                    </div>
                    <div className={style.subject}>
                      <p>
                        Assign Approver(s) <b className={style.red_mendantory}>*</b>{' '}
                      </p>
                      <div className={style.assignTextIcon}>
                        <svg
                          style={{ position: 'absolute', top: '16px', left: '18px', zIndex: '1' }}
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect y="0.5" width="20" height="20" rx="4" fill="#272727" />
                          <path
                            d="M5.64103 10.7693H9.23072V14.359C9.23072 14.7179 9.51278 15 9.87175 15C10.2307 15 10.5128 14.7179 10.5128 14.359V10.7693H14.359C14.7179 10.7693 15 10.4872 15 10.1283C15 9.76928 14.7179 9.48722 14.359 9.48722H10.5128V5.64103C10.5128 5.28206 10.2307 5 9.87175 5C9.51278 5 9.23072 5.28206 9.23072 5.64103V9.48722H5.64103C5.28206 9.48722 5 9.76928 5 10.1283C5 10.4872 5.28206 10.7693 5.64103 10.7693Z"
                            fill="white"
                          />
                        </svg>
                        <input
                          type="search"
                          className={`${style.input_search} ${style.paddingInput} ${style.approverPaddingInput}`}
                          style={{ paddingLeft: '48px' }}
                          id="searchInput"
                          placeholder="Search approver name"
                          value={approvalsfreeTaginput}
                          onChange={(e) => ApprovalLists(e.target.value)}
                          autoComplete="off"
                          disabled={taskId && !isEditFields}
                          onBlur={() => {
                            if (!onMouseHover) {
                              ApprovalLists('');
                              //setmultiSubjectTag([]);
                              setAssigneefreeTagStatus(false);
                              setAssigneefreeTag([]);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={style.try}>
                    {/* this is input field for  searching */}
                    <div style={{ width: '40%' }} className={style.input_search}>
                      {assigneefreeTagStatus ? (
                        <div
                          onMouseOver={() => {
                            setOnMouseHover(true);
                          }}
                          onMouseLeave={() => {
                            setOnMouseHover(false);
                          }}
                          className={style.list_input_primary}
                        >
                          {assigneefreeTag?.map((items, i) => (
                            <NativeButton
                              key={items.name + i}
                              onClick={() => {
                                selectAssigneeTag(items);
                                setOnMouseHover(false);
                              }}
                            >
                              <div className={style.pointer}>
                                <span>{items.name} </span>
                              </div>
                            </NativeButton>
                          ))}
                        </div>
                      ) : (
                        ''
                      )}
                    </div>

                    {/* this is input field for approval searching */}
                    <div style={{ width: '40%' }} className={style.input_search_ok} x>
                      {/* Selected Approvals */}
                      {approversInfo?.map((items, i) => (
                        <span key={items.full_name + i} className={`${style.selected_tags} ${style.asignees}`}>
                          {items.name}{' '}
                          {isEditFields && (
                            <div className={style.cancel_button}>
                              <button className={style.pointer} onClick={() => cancelApprovalButoon(i)}>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.75781 7.75781L16.2431 16.2431"
                                    stroke="#272727"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M7.75691 16.2431L16.2422 7.75781"
                                    stroke="#272727"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </button>
                            </div>
                          )}
                        </span>
                      ))}

                      {/* list of items of pre-defined multifree tag  */}
                      {approvalsfreeTagStatus ? (
                        <div
                          onMouseOver={() => {
                            setOnMouseHover(true);
                          }}
                          onMouseLeave={() => {
                            setOnMouseHover(false);
                          }}
                          className={style.list_input_primary}
                        >
                          {approvalsfreeTag.map((items, i) => (
                            <NativeButton
                              key={i + items.name}
                              onClick={() => {
                                selectApprovalTag(items);
                                setOnMouseHover(false);
                              }}
                            >
                              <div className={style.pointer}>
                                <span>{items.name} </span>
                              </div>
                            </NativeButton>
                          ))}
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>

                <div className={style.user_profile}>
                  <div className={style.tags}>
                    <div className={style.subject}>
                      <p>
                        End Date <b className={style.red_mendantory}>*</b>{' '}
                      </p>
                      <input
                        type="date"
                        style={{
                          padding: '14px',
                          color: endDateInfo || (endDateInfo != '' && endDateInfo != null) ? 'black' : '#8E9EAB',
                        }}
                        className={`${style.input_search} ${style.date_icon} ${style.inputWidth}`}
                        id="searchInput"
                        onChange={(e) => setEndDateInfo(e.target.value)}
                        min={date}
                        placeholder="DD/MM/YY"
                        autoComplete="off"
                        value={endDateInfo}
                        disabled={taskId && !isEditFields}
                      />
                    </div>
                    {taskType === 1 && (
                      <div className={style.subject}>
                        <p>
                          No. of Questions <b className={style.red_mendantory}>*</b>
                        </p>
                        <input
                          className={`${style.input_search} ${style.inputWidth} ${style.paddingInput}`}
                          type="number"
                          id="searchInput"
                          onChange={(e) => NumOfQuestions(e)}
                          onKeyDown={(event) => {
                            if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                              event.preventDefault();
                            }
                          }}
                          onWheel={(e) => e.target.blur()}
                          placeholder="Enter no.of questions"
                          autoComplete="off"
                          value={numberOfQue}
                          disabled={taskId && !isEditFields}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className={style.user_profile}>
                  <div className={style.tags}>
                    <div className={style.subject} style={{ width: '70%' }}>
                      <p>
                        Task Details <b className={style.red_mendantory}>*</b>{' '}
                      </p>
                      <textarea
                        style={{
                          width: '100%',
                          height: '110px',
                          borderRadius: '12px',
                          resize: 'none',
                          padding: '20px',
                          outline: 'none',
                          border: '2px solid #ECF3F5',
                          marginBottom: '2em',
                        }}
                        className={style.input_search}
                        type="search"
                        id="searchInput"
                        onChange={(e) => setTaskDetailsInfo(e.target.value)}
                        value={taskDetailsInfo}
                        placeholder="Enter task details"
                        disabled={taskId && !isEditFields}
                      />
                    </div>
                  </div>
                </div>
                <div className={`${style.saveButton_questionBank} ${style.margin_top_save}`}>
                  <NativeButton onClick={handleCancel}>
                    <div className={` ${style.cancel} ${style.pointer}`}> {taskId ? 'Reset' : 'Clear'}</div>
                  </NativeButton>
                  <div>
                    <button className={style.blue_button} onClick={handleAssignTask}>
                      {taskId ? 'Update Task' : 'Assign Task'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <RecentActivity />
          </>
        )}
      </PageLayout>
      <div>
        {modal && (
          <BrowsingQuestion
            setSelectIds={setSelectIds}
            selectIds={selectIds}
            selectedIds={[]}
            setModal={setModal}
            selectedQuestionId={selectedQuestionId}
            setSelectedQuestionId={setSelectedQuestionId}
            totalQuestion={1}
            addQuestionToTask={addQuestionToTask}
          />
        )}
      </div>
    </>
  );
};

export default AddTask;
